/**
 * @description i18n en
 * @author wangfupeng
 */

export default {
  listModule: {
    unOrderedList: 'Unordered list',
    orderedList: 'Ordered list',
    lowerAlphaList: 'Ordered list (a,b,c)',
  },
}
